import { render, staticRenderFns } from "./Share.vue?vue&type=template&id=8767db60&scoped=true"
import script from "./Share.vue?vue&type=script&lang=js"
export * from "./Share.vue?vue&type=script&lang=js"
import style0 from "./Share.vue?vue&type=style&index=0&id=8767db60&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8767db60",
  null
  
)

export default component.exports